export default __webpack_public_path__ + "static/guide-0457d92836c476c66e0d9011b898b38e.svg";